/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Section3_TitleInputs */

const en_privacy_section3_title = /** @type {(inputs: Privacy_Section3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Local Storage`)
};

const ko_privacy_section3_title = /** @type {(inputs: Privacy_Section3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`로컬 저장소`)
};

const ja_privacy_section3_title = /** @type {(inputs: Privacy_Section3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ローカルストレージ`)
};

/**
* | output |
* | --- |
* | "Local Storage" |
*
* @param {Privacy_Section3_TitleInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const privacy_section3_title = /** @type {((inputs?: Privacy_Section3_TitleInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Section3_TitleInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_privacy_section3_title(inputs)
	if (locale === "ko") return ko_privacy_section3_title(inputs)
	return ja_privacy_section3_title(inputs)
});